module.exports = __webpack_public_path__ + "static/media/bg.86ba6533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = 2166
// module chunks = 0